export function convertToCSV(arr) {
	const header = Object.keys(arr[0]).join(","); // Extract the keys as header
	const rows = arr.map(obj => Object.values(obj).join(",")); // Extract the values as rows
	return [header, ...rows].join("\n"); // Combine header and rows with line breaks
}

export function exportToCSV(data, filename) {
	const csv = convertToCSV(data);
	const csvBlob = new Blob([csv], {type: "text/csv;charset=utf-8;"});

	if (navigator.msSaveBlob) {
		// For Microsoft Edge and IE
		navigator.msSaveBlob(csvBlob, filename);
	} else {
		// For other browsers
		const csvURL = URL.createObjectURL(csvBlob);
		const tempLink = document.createElement("a");
		tempLink.href = csvURL;
		tempLink.setAttribute("download", filename);
		tempLink.click();
	}
}
